var _path, _path2, _path3, _path4, _path5, _polygon, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "130px",
    height: "130px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M10,82.5c7.171,0,13.665-2.907,18.364-7.606c5.072-5.073,11.72-7.607,18.364-7.607c3.521,0,6.876,0.704,9.94,1.972V44.473 c-3.064-1.27-6.419-1.975-9.94-1.975c-6.644,0-13.292,2.536-18.364,7.608C23.665,54.806,17.171,57.714,10,57.714V82.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M48.556,67.375c2.853,0.202,5.586,0.837,8.112,1.883v-8.332C52.714,60.926,49.409,63.682,48.556,67.375z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M56.668,52.806v-8.333c-2.526-1.048-5.26-1.684-8.112-1.883c-0.141,0.606-0.222,1.235-0.222,1.883 C48.334,49.075,52.065,52.806,56.668,52.806z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M10,66.046c4.602,0,8.333-3.729,8.333-8.332c0-0.457-0.047-0.899-0.117-1.335c-2.583,0.861-5.344,1.335-8.216,1.335V66.046z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M10,74.168V82.5c2.872,0,5.633-0.474,8.216-1.335C17.575,77.2,14.146,74.168,10,74.168z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 60,25 60,40.001 75.001,40.001 60,40.001 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M60,16.249c-13.117,0-23.751,10.634-23.751,23.75c0,1.549,0.168,3.056,0.453,4.52c3.202-1.34,6.612-2.021,10.026-2.021 c3.521,0,6.876,0.705,9.94,1.975v2.501v3.146c2.634,0.247,5.152,0.879,7.5,1.853v11.374c11.125-1.971,19.581-11.657,19.581-23.348 C83.749,26.883,73.118,16.249,60,16.249z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M60,10c-16.569,0-30,13.431-30,29.999c0,2.701,0.385,5.306,1.063,7.791c1.767-1.342,3.657-2.442,5.64-3.271 c-0.285-1.464-0.453-2.971-0.453-4.52c0-13.116,10.634-23.75,23.751-23.75c13.118,0,23.749,10.634,23.749,23.75 c0,11.69-8.456,21.377-19.581,23.348v6.308C78.758,67.621,90,55.148,90,39.999C90,23.431,76.569,10,60,10z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M56.668,50.12v19.138c-3.064-1.268-6.419-1.972-9.94-1.972c-6.644,0-13.292,2.534-18.364,7.607 c-3.577,3.577-8.199,6.106-13.365,7.114V90c7.039-1.049,13.543-4.269,18.668-9.395c3.488-3.488,8.126-5.409,13.06-5.409 c2.444,0,4.825,0.472,7.074,1.402l10.366,4.289V51.973C61.82,50.999,59.302,50.367,56.668,50.12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.74e264e0d07297d49c41b694cf7a6c69.svg";
export { ForwardRef as ReactComponent };